module.exports = require("./es-CO.d.ts");